import { useSetPrimaryPaymentMethodMutation } from "../../../../../api/patient/useSetPrimaryPaymentMethodMutation";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";

export const useSetPrimaryPm = (patientId) => {
  const { tCommon: t } = useAppTranslation.Common();

  const { mutateAsync, isLoading } = useSetPrimaryPaymentMethodMutation({
    onError: () => {
      uiNotification.error(t("error.setPrimaryCC"));
    },
    onSuccess: () => {
      uiNotification.success(t("success.setPrimaryCC"));
    },
  });

  const initiate = (pmId) => {
    return mutateAsync({ patientId: Number(patientId), pmId });
  };

  return {
    initiate,
    isLoading,
  };
};
